/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendAdditionalProjectInformationFieldDto } from '../../models/backend-additional-project-information-field-dto';
import { BackendAdditionalProjectInformationFieldRequestDto } from '../../models/backend-additional-project-information-field-request-dto';

export interface ProjectsAdditionalProjectInformationUpdate$Params {
  id: number;
  body?: BackendAdditionalProjectInformationFieldRequestDto;
}

export function projectsAdditionalProjectInformationUpdate(
  http: HttpClient,
  rootUrl: string,
  params: ProjectsAdditionalProjectInformationUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendAdditionalProjectInformationFieldDto>> {
  const rb = new RequestBuilder(rootUrl, projectsAdditionalProjectInformationUpdate.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendAdditionalProjectInformationFieldDto>;
    }),
  );
}

projectsAdditionalProjectInformationUpdate.PATH = '/api/projects/additional_project_information/{id}/';
